import { useContext } from 'react';

import { BrandAnalysisDataContext } from './BrandAnalysisDataContext';

import type { BrandAnalysisData } from './types';

export const useBrandAnalysisData = (): BrandAnalysisData => {
  const context = useContext(BrandAnalysisDataContext);
  if (context === undefined) {
    throw new Error(
      'useBrandAnalysisData must be used within a BrandAnalysisDataProvider',
    );
  }
  return context.data;
};
